module.exports = "<div class=\"col-xs-12 col-md-4\" ng-repeat=\"city in $ctrl.cityList\">\n  <div class=\"Cities-List-Item\">\n    <ul>\n      <li><a ui-sref=\"guides.city({country: $ctrl.country, city: city.slug })\">{{city.name}} <span class=\"Cities-List-LocalCount\">{{city.count | round}}</span></a></li>\n    </ul>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/modules/cities/city_list/city_list.html
// module id = 754
// module chunks = 12